import { twMerge } from "tailwind-merge";
import moment from "moment-timezone";
import { Badge } from "@shared/ui/Badge";
import { Type } from "@shared/ui/Type";
import { ProgramPhaseActionButton } from "./ProgramPhaseActionButton";
import { PhaseAction } from "@platform/types/platform.types";
import { useProgramPhaseAction } from "../../hooks/useProgramPhaseAction";
import { TimezoneOption } from "@platform/features/timezones/timezones.types";

type Props = {
  action: PhaseAction;
  disabled: boolean;
  userTimezoneOption: TimezoneOption;
};

export function ProgramPhaseActionItem({
  action,
  disabled,
  userTimezoneOption,
}: Props) {
  const { name, description } = action;

  const {
    actionLabel,
    actionBadge,
    onActionClick,
    isActionDisabled,
    statusLabel,
    isActionCompleted,
    isActionAvailable,
  } = useProgramPhaseAction(action, userTimezoneOption);

  return (
    <>
      <div
        className={twMerge(
          "flex flex-col p-4 items-center h-full justify-between border-t border-brand-700 md:flex-row md:rounded-md md:border",
          ((isActionCompleted && !isActionAvailable) || disabled) &&
            "opacity-50 flex-row"
        )}
      >
        <div className="flex flex-col gap-2 md:pr-4 overflow-hidden">
          <Type variant="h6">
            {name}{" "}
            {statusLabel && (
              <span className="text-brand-700">({statusLabel})</span>
            )}
          </Type>
          {actionBadge && (
            <Type variant="h6" className="text-brand-700">
              Your role: {actionBadge}
            </Type>
          )}
          <Type variant="caption" className="text-brand-700">
            {description}
          </Type>
        </div>
        <ProgramPhaseActionButton
          label={actionLabel}
          isAvailable={isActionAvailable}
          isCompleted={isActionCompleted}
          isDisabled={disabled}
          isButtonDisabled={isActionDisabled}
          onClick={onActionClick}
        />
      </div>
    </>
  );
}

export default ProgramPhaseActionItem;
